import React, {useRef, useState} from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {H3} from "BaseComponents/Text";

export const StickyBlockItem = ({item}) => {
    return <StickyItemWrapper>
        <StickyItem target={item.Link?.Target ?? "_self"}
                    href={item.Link.Url}
                    text={item.Link.Name}
                    ariaLabel={item.Link.Name}
                    bgColor={item.BackgroundColor}>
            <StickyItemIcon>
                <img alt={item?.Title ?? 'icon'} src={item?.Icon}/>
            </StickyItemIcon>
            <StickyItemText isMobile={true}>{item?.Title}</StickyItemText>
        </StickyItem>
        <StickyItemText isMobile={false}>{item?.Title}</StickyItemText>
    </StickyItemWrapper>
};

export const StickyBlock = ({Title, Items}) => {
    const [isOpen, setIsOpen] = useState(false);
    const stickyContainer = useRef(null);

    const clickOpenMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <StickyContainer ref={stickyContainer} className={'stickyBlock'}>
            <StickyHeadingContainer>
                {Title && <H3Sticky>{Title}</H3Sticky>}
                <StickyMobileButton onClick={clickOpenMenu}><i
                    className={isOpen ? 'fas fa-angle-up' : 'fas fa-angle-down'}/></StickyMobileButton>
            </StickyHeadingContainer>
            <StickyItemContainer className={isOpen ? '' : 'hide'}>
                {Items.map((r, key) => {
                    return <StickyBlockItem key={key} item={r}/>
                })}
            </StickyItemContainer>
        </StickyContainer>
    );
};

export const StickyMobileButton = styled.button`
    height: 48px;
    width: 48px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    border-radius: 100px;
    display: none;

    color: ${({theme}) => theme.colors.white};
    background-color: ${({theme}) => theme.colors.primary};
    border-color: transparent;
    outline: none;

    &:focus {
        outline: none;
    }

    ${media.lessThan(breakpoints.ipadPro)`       
        display: flex;
    `}
`;

export const H3Sticky = styled(H3)`
    display: none;
    align-items: center;
    ${media.lessThan(breakpoints.ipadPro)`
        display: flex;
    `}
`;
export const StickyHeadingContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;

    ${media.lessThan(breakpoints.ipadPro)`       
        min-height: 48px;
    `}
    h3 {
        flex: 1;
    }
`;

export const StickyItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: calc(100% / 4 - (1rem * 3 / 4));
    ${media.lessThan(breakpoints.ipadPro)`
        flex-basis: calc(100% / 2 - (1rem / 2));
        aspect-ratio: unset;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        max-height: 84px;
        gap: 1.5rem;
        max-width: unset;
    `}
    ${media.lessThan(breakpoints.mobile)`
        flex-basis: 100%;
        max-width: unset;
        aspect-ratio: unset;          
        max-height: 60px;    
    `}    
`;

export const StickyItem = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1 / 1;
    flex: 1;
    border-radius: 400px;
    padding: 1rem;
    background-color: ${({bgColor, theme}) => (bgColor ? `#${bgColor}` : theme.colors.white)};
    gap: 8px;
    max-width: 110px;
    max-height: 110px;
    outline: none;
    -webkit-appearance: none;
    box-shadow: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    transition: all .3s ease-in-out;

    &:focus,
    &:active {
        outline: solid 1px ${({theme}) => (theme.colors.gray)};
        text-shadow: none;
        box-shadow: none;
        -webkit-appearance: none;
    }

    &:hover {
        transform: scale(1.03);
        outline: none;
        text-shadow: none;
        box-shadow: none;

        span {
            text-decoration: underline;
        }
    }

    ${media.lessThan(breakpoints.ipadPro)`
        flex-basis: calc(100% / 2 - (1rem / 2));
        aspect-ratio: unset;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        max-height: 84px;
        padding: 1rem 1.5rem;
        gap: 1.5rem;
        max-width: unset;
    `}
    ${media.lessThan(breakpoints.mobile)`
        flex-basis: 100%;
        max-width: unset;
        aspect-ratio: unset;          
        max-height: 60px;    
    `}
`;

export const StickyItemText = styled.span`
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-family: "DINOT";
    color: ${({theme}) => theme.colors.black};
    align-self: stretch;
    display: ${({isMobile}) => (isMobile ? "none" : "block")};
    ${media.lessThan(breakpoints.ipadPro)`
        align-self: center;
        flex: 1;
        text-align: left;
        display: ${({isMobile}) => (isMobile ? "block" : "none")};
    `}

`;

export const StickyItemIcon = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;

    img {
        height: 100%;
        max-width: 100%;
        ${media.lessThan(breakpoints.ipadPro)`
            height: 48px;
        `}
    }
`;

export const StickyItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;
    margin-top: 20px;

    ${media.lessThan(breakpoints.ipadPro)`
        gap: 1rem; 
        flex-wrap: wrap;
        &.hide {
            display: none;
        }   
    `}

`;
export const StickyContainer = styled.div`
    background-color: ${({theme}) => theme.colors.white};
    border-top: 1px solid ${({theme}) => theme.colors.grey};
    margin-top: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    position: fixed;
    bottom: 0;
    z-index: 2;

    ${media.lessThan(breakpoints.ipadPro)`
        left: 0;
        right: 0;
        margin:0 auto;
        padding-left: 20px;
        padding-right: 20px;
	    width: calc(100% - 40px);
    `}
    ${media.lessThan(breakpoints.mobile)`
         width: 100%;
    `}
`;
